<template>
<div>
    <BreadCrumb class="bread" :breads="['商品管理','模板管理']"></BreadCrumb>
    <div class="wrap">
        <div class="header">
            <span class="nameFt">模板管理</span>
        </div>
    </div>
    <div class="submit-form">
        <el-form :model="search" :inline="true" size="small" label-width="80px">
            <div class="submit-form__search">
                <el-form-item label="模板名称">
                    <el-input v-model="search.name"></el-input>
                </el-form-item>
            </div>
            <div class="submit-form__operate">
                <el-form-item>
                    <el-button class="queryBtn" size="small" type="primary" @click="searchForm">查询</el-button>
                    <el-button class="queryBtn" size="small" type="primary" @click="reset">重置</el-button>
                </el-form-item>
            </div>
        </el-form>
    </div>
    <div class="operate-con" v-show="$store.getters.authority({name:'shopModel',type:'add'})">
        <el-button size="small" @click="openAdd()">新增</el-button>
    </div>
    <div class="table-con">
        <el-table :data="tableList" stripe>
            <el-table-column label="序号" type="index" align="center" :index="indexMethod"></el-table-column>
            <el-table-column label="模板名称" align="center" prop="template_name"></el-table-column>
            <el-table-column label="产品型号" align="center" prop="terminal_type_name"></el-table-column>
            <el-table-column label="层数" align="center" prop="terminal_rows"></el-table-column>
            <el-table-column label="列数" align="center" prop="terminal_column"></el-table-column>
            <el-table-column label="商品分类" align="center" prop="goods_type_count"></el-table-column>
            <el-table-column label="商品种类" align="center" prop="items_count"></el-table-column>
            <el-table-column label="满仓数" align="center" prop="qty_count"></el-table-column>
            <el-table-column label="创建时间" align="center" prop="created_at"></el-table-column>
            <el-table-column label="模板分配设备" align="center">
                <div slot-scope="scope">
                    <el-button type="text" size="small" @click="openCabinet(scope.row.id)">设备选择</el-button>

                </div>
            </el-table-column>
            <el-table-column label="操作" align="center">
                <div slot-scope="scope">

                    <el-button type="text" size="small" @click="allocateItem(scope.row.id,1)" :disabled="!canDoAction(scope.row.id)">删除模板中</br>所有不存在的 </el-button>

                </div>
            </el-table-column>
            <el-table-column label="操作" align="center" style="width:500px">
                <div slot-scope="scope">
                    <el-button type="text" size="small" @click="allocateItem(scope.row.id,2)" :disabled="!canDoAction(scope.row.id)">删除模板中</br>不存在且真实</br>数量为0的</el-button>
                </div>
            </el-table-column>
            <el-table-column label="操作" align="center" style="width:300px">
                <div slot-scope="scope">
                    <el-button type="text" size="small" @click="allocateItem(scope.row.id,3)" :disabled="!canDoAction(scope.row.id)">完全保留原陈列</el-button>
                </div>
            </el-table-column>
            <el-table-column label="操作" align="center" style="width:260px">
                <div slot-scope="scope">
                    <el-button type="text" size="small" @click="openView(scope.row.id)">查看</el-button>
                    <el-button type="text" size="small" @click="openUpdate(scope.row.id)" v-show="$store.getters.authority({name:'shopModel',type:'update'})">修改</el-button>
                    <el-button type="text" size="small" @click="deleteItem(scope.row.id)" v-show="$store.getters.authority({name:'shopModel',type:'delete'})">删除</el-button>
                </div>
            </el-table-column>

        </el-table>
    </div>
    <div style="padding:10px;color:red;">
        模板分配操作:1、删除模板中所有不存在的 2、删除模板中不存在且真实数量不为0的 3、完全保留原陈列
    </div>
    <div class="paginationWrap">
        <el-pagination @current-change="handleCurrentChange" :page-size="pageSize" :current-page="pageNum" :layout="pageLayout" :total="total">
        </el-pagination>
    </div>

    <el-dialog :visible.sync="cabinetVisible" width="800px" title="设备选择" @close="closeDialog" >
        <el-form :model="search" :inline="true" size="small" label-width="90px">
            <div style="display: flex; width:750px">
                <div class="submit-form__search">
                    <el-form-item label="线路名称" prop="line">
                        <el-input size="small" v-model="line" style="width:200px" readonly @focus="openSimpleFindDialog('line')" suffix-icon="el-icon-search"></el-input>
                    </el-form-item>
                </div>
                <div class="submit-form__operate">
                    <el-form-item>
                        <el-button class="queryBtn" size="small" type="primary" @click="searchForm1">查询</el-button>
                        <el-button class="queryBtn" size="small" @click="reset1">重置</el-button>
                    </el-form-item>
                </div>
            </div>

        </el-form>
        <el-button type="primary" size="small" @click="addToList">加入设备清单</el-button>
        <el-button type="success" size="small" @click="openSelectedList">查看设备清单</el-button>

        <el-table :data="itemList" stripe v-loading="loading" style="width: 100%" ref="multipleTable" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55">
            </el-table-column>
            <el-table-column label="序号" type="index" align="center" :index="indexMethod"></el-table-column>
            <el-table-column label="机器编号" align="center" prop="hard_number"></el-table-column>
            <el-table-column label="线路名称" align="center" prop="line_name"></el-table-column>
            <el-table-column label="点位名称" align="center" prop="point_name"></el-table-column>

        </el-table>
        <div class="paginationWrap">
              <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChangeCabinet"
            :page-sizes="[10,20,30,50,100]"
            :page-size="page_size"
            :current-page="page_index"
            layout="total,sizes, prev, pager, next"
            :total="itemsPaging.total_count"
          >
          </el-pagination>
            <!-- <el-pagination @current-change="handleCurrentChangeCabinet" :page-size="10" :current-page="itemsPaging.page_index" layout="total, prev, pager, next" :total="itemsPaging.total_count">
            </el-pagination> -->
        </div>
    </el-dialog>

     <el-dialog :visible.sync="cabinetVisibleLook" width="800px" title="查看已选设备"  :show-close="false">

        
     
        <el-table :data="selectedList" stripe v-loading="loading" style="width: 100%" ref="multipleTable" @selection-change="handleSelectionChange">
            <!-- <el-table-column type="selection" width="55">
            </el-table-column> -->
            <el-table-column label="序号" type="index" align="center" :index="indexMethod"></el-table-column>
            <el-table-column label="机器编号" align="center" prop="hard_number"></el-table-column>
            <el-table-column label="线路名称" align="center" prop="line_name"></el-table-column>
            <el-table-column label="点位名称" align="center" prop="point_name"></el-table-column>
             <el-table-column prop="hard_number" label="操作" align="center">
                <template slot-scope="scope">
                    <el-button type="text" size="mini" @click="removeCabinetItem(scope.row)">移除</el-button>
                </template>
            </el-table-column>

        </el-table>
        <div style="width:100%;text-align: center;margin:20px auto">
 <el-button type="success" size="small" v-if="selectedList.length>0" @click="confirmSelectedList">确 定</el-button>
  <el-button type="danger" size="small"   @click="cabinetVisibleLook=false">关 闭</el-button>
        </div>
          

     
    </el-dialog>
    <simple-find-dialog :show="dialogVisible" :dialogData="dialogData" @close="closeSimpleDialog" :width="'500px'"></simple-find-dialog>

</div>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb";
import apis from "@/config/apis";
import alert from "@/plugins/alert";
import listMixin from "@/mixins/list";
import SimpleFindDialog from "@/components/SimpleFindDialog";
export default {
    components: {
        BreadCrumb,
        SimpleFindDialog,

    },
    data() {
        return {
            search: {
            },
            pagination: {},
            tableData: [],
            itemList: [],
            cabinetVisible: false,
            cabinetVisibleLook:false,
            multipleSelection: [],
            selectedAllList: [],
            currentRowId: null, // 当前点击设备选择的模板ID（第一张表
            dialogData: {},
            nowDialogType: "",
            dialogVisible: false,
            line: "",
            line_id: "",
            itemsPaging: {},
            page_index: 1,
            page_size: 10,
            selectedPageRows: [], // 当前页勾选的数据
            selectedList: [], // 全局设备清单（不会因分页丢失）
            idList:[],
            isSelect:false,
        };
    },

    mixins: [listMixin],
 
    created() {
        this.search = Object.assign(this.search, this.$route.query);
        this.getData();
    },
    methods: {
        getData() {
            this.getTableData(apis.template_list, "get", this.search);
        },
        searchForm() {
            this.search.page_index = 1;
            this.getData();
        },
        searchForm1() {
            this.loading = true;
            this.getCabinet();
        },
        reset1() {
            this.loading = true;
            this.line = "",
                this.line_id = "";
            this.getCabinet();
        },
        reset() {
            this.search = {};
            this.search.page_index = 1;
            this.getData();
        },
        handleCabinetClose() {
            this.itemList = [];
        },
        addToList() {
            if (this.selectedPageRows.length === 0) {
                this.$message.warning("请选择设备后再加入");
                return;
            }

            // 去重：根据 hard_number 去重
            const newItems = this.selectedPageRows.filter(row =>
                !this.selectedList.some(s => s.hard_number === row.hard_number)
            );

            this.selectedList = this.selectedList.concat(newItems);

            this.$message.success("已加入设备清单");
        },
        openSelectedList(){
            this.cabinetVisibleLook = true;
        },
        confirmSelectedList(){
            console.log('12345678')
            this.$message.success("成功加入模板分配设备的机器编号")
            this.cabinetVisibleLook = false;
            this.cabinetVisible = false;
            this.isSelect = true;
            this.idList = this.selectedList.map(item => item.id);
            
           
        },
        openSimpleFindDialog(type) {
            switch (type) {
                case "line":
                    this.dialogData = {
                        searchItems: [{
                            key: "name",
                            label: "线路名称",
                        }, ],
                        searchTableItem: [{
                            key: "name",
                            name: "线路名称",
                        }, ],
                        proxyLink: "terminal_line",
                        proxyType: "get",
                    };
                    break;
            }
            this.nowDialogType = type;
            this.dialogVisible = true;
        },
        cabinetConfirm() {
            console.log(this.multipleSelection, 'this.itemList')
        },
        handleSizeChange(val){
            this.page_size = val;
            this.page_index = 1;
            this.getCabinet();
        },
        removeCabinetItem(row){
            this.selectedList = this.selectedList.filter((item) => item.hard_number !== row.hard_number);

        },
        closeDialog(){
            // this.selectedList = [];
        },
        //关闭上侧选择
        closeSimpleDialog(data) {
            if (data) {
                switch (this.nowDialogType) {
                    case "line":
                        this.line = data.name;
                        this.line_id = data.id;
                        break;
                }
            }
            this.dialogVisible = false;
        },
        //打开模板详情
        openView(id) {
            this.$router.push({
                name: "cabinetUpdate",
                query: {
                    id: id,
                    operateType: "modelLook"
                }
            });
        },
        openAdd() {
            this.$router.push({
                name: "cabinetUpdate",
                query: {
                    operateType: "modelAdd"
                }
            });
        },
        openUpdate(id) {
            this.$router.push({
                name: "cabinetUpdate",
                query: {
                    id: id,
                    operateType: "modelUpdate"
                }
            });
        },
        openCabinet(id) {
            this.selectedList = [];
            this.currentRowId = id; // 🔥 记录当前主表格行
            this.cabinetVisible = true;
            this.loading = true;
            this.getCabinet();

        },
        getCabinet() {
            this.$axios
                .get(apis.template_terminal_list, {
                    params: {
                        line_id: this.line_id,
                        page_index: this.page_index,
                        page_size: this.page_size
                    }
                }).then(res => {
                    this.loading = false;
                    this.itemList = res.data.data;
                    this.itemsPaging = res.data.pagination;

                })

        },
        handleCurrentChangeCabinet(val) {
            this.page_index = val;
            this.getCabinet();
        },
        canDoAction(rowId) {
            // 必须是当前点击的那一行（currentRowId）
            // 且第二个表格至少勾选 1 个
            return rowId === this.currentRowId && this.selectedList.length > 0;
        },
        handleSelectionChange(val) {
             this.selectedPageRows = val;
            // // val 是选中的行数组
            // this.multipleSelection = val.map(item => item.id);

            // console.log(this.multipleSelection, '选中的ID');
        },
        deleteItem(id) {
            alert.deleteAlert().then(res => {
                this.$axios
                    .delete(apis.template_delete, {
                        params: {
                            id: id
                        }
                    })
                    .then(res => {
                        if (res.data.code === 200) {
                            this.$message({
                                type: "success",
                                message: "删除成功"
                            });
                            this.getData();
                        } else {
                            this.$message({
                                type: "error",
                                message: res.data.msg
                            });
                        }
                    });
            });
        },
        allocateItem(id, type) {
            let jsonData = {
                terminal_ids: this.idList,
                template_id: this.currentRowId,
                displayed_delete: type

            }
            alert.restockAlert().then(res => {
                this.$axios
                    .post(apis.template_allocate_terminal, jsonData)
                    .then(res => {
                        if (res.data.code === 200) {
                            this.$message({
                                type: "success",
                                message: "操作成功"
                            });
                            this.getData();
                        } else {
                            this.$message({
                                type: "error",
                                message: res.data.msg
                            });
                        }
                    });
            });
        }
    }
};
</script>

<style lang="scss" scoped>
</style>
